import React from 'react';
import { SxStyle } from '../../../../types';
import { BottomBarPreviewItem } from '../types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppMenuItemIcon from './app-menu-preview-item-icon';
import Typography from '@mui/material/Typography';
import { PaletteColors } from '../../../../types/app-config';

const styles: SxStyle = {
  container: {
    borderTop: '1px solid',
    width: '100%',

    '& > :not(:last-child)': {
      borderBottom: '1px solid rgba(255, 255, 255, 0.10)',
    },
  },
  item: {
    height: '50px',
    alignItems: 'center',
    paddingX: 1,
  },
  text: {
    textTransform: 'uppercase',
    fontSize: '12px',
  },
};

interface Props {
  palette?: PaletteColors | null;
  bottomBarItemsSecondary?: BottomBarPreviewItem[];
}

const AppMenuPreviewMenu = ({ palette, bottomBarItemsSecondary }: Props) => {
  return (
    <Box
      sx={{
        ...styles.container,
        ...{ borderTopColor: palette?.ID_CONTRAST || 'white' },
        ...{ backgroundColor: palette?.ID_MAIN || 'black' },
      }}
    >
      {bottomBarItemsSecondary?.map((item) => (
        <Stack key={item.id} sx={styles.item} direction="row" spacing={1}>
          <AppMenuItemIcon icon={item.icon} />
          <Typography variant="body2-bold" sx={styles.text}>
            {item.text}
          </Typography>
        </Stack>
      ))}
    </Box>
  );
};

export default AppMenuPreviewMenu;
